/* Collection of random reusable code snippets that don't belong in other files for now */

// Need a custom loader to stop NextJS Image component from encoding urls. This function
// basically just overrides the default loader by returning the same url sent in.
// Reference link - https://stackoverflow.com/questions/70457750/nextjs-not-fetching-images-using-image-url-after-deploying-on-production-server/71377671#71377671
export const loaderProp = ({ src }) => {
  return src;
};
